/**
 * Campaign-page tracker dispatch. The Campaigns page takes its tracker from
 * `?provider=`; on dev every value that was not "binom" read Voluum's routes,
 * and the by-provider hooks fetched nothing for a value that names no tracker.
 * These helpers keep exactly that for such a value, and give every tracker id
 * (Tres Commas included) its own branch.
 * For Media Devoted | Created By Ciro Autiero
 */

import { parseTrackerId, TRACKER_IDS, type TrackerId } from '@trafficpulse/shared';

import type { CampaignProvider } from '@/hooks/voluum/useVoluum';

/** The tracker whose routes serve `provider`; a value naming no tracker keeps dev's Voluum fallback. */
export function dispatchTracker(provider: CampaignProvider): TrackerId {
  return parseTrackerId(provider) ?? 'voluum';
}

/** `id` for the hook of the tracker `provider` names and '' (query off) for every other tracker. */
export function idsByTracker(provider: CampaignProvider, id: string): Record<TrackerId, string> {
  const own = parseTrackerId(provider);
  const entries = TRACKER_IDS.map((tracker) => [tracker, tracker === own ? id : '']);
  return Object.fromEntries(entries) as Record<TrackerId, string>;
}

/** The answer of the tracker `provider` names (Voluum's for a value naming no tracker, as on dev). */
export function pickTracker<T>(provider: CampaignProvider, byTracker: Record<TrackerId, T>): T {
  return byTracker[dispatchTracker(provider)];
}
